var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('v-layout',{attrs:{"row":"","px-2":"","mt-2":"","justify-end":_vm.right}},[_c('v-icon',{attrs:{"color":"primary_ink"}},[_vm._v("error_outline")]),_vm._v(" "),_c('p',{staticClass:"mb-0 ml-2 color-red"},[_vm._v("\n    "+_vm._s(_vm.warningText)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }